import React from "react";
import './SuccessIcon.css';
import greenCheck from '../../../assets/icons/icon-success.svg';

interface ISuccesIconProps {
    showIcon: boolean;
}

const SuccessIcon = ({ showIcon }: ISuccesIconProps) => {
    return (
        <div className={"SuccessIcon__successIconContainer"}>
            <img className={showIcon ? '' : 'SuccessIcon__iconSuccess--hidden'} src={greenCheck} alt={'success icon'} />
        </div>
    )
}
export default SuccessIcon